import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "lib-flexible";
import MintUI from "mint-ui";
// import 'mint-ui/lib/style.css'
import "./assets/style.css";
import { routerChangeEvent } from "./static/js/common";


Vue.use(MintUI);
Vue.config.productionTip = false;
// 路由守卫
router.beforeEach((to, from, next) => {
  routerChangeEvent(to, from, next);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
